const { PLATFORM_CODES } = require('./constants');

const marketingPrefEnabledPlatforms = [
  PLATFORM_CODES.CES,
  PLATFORM_CODES.HUB,
  PLATFORM_CODES.OTE,
  PLATFORM_CODES.OPT,
  PLATFORM_CODES.INSP
];

const isMarketingPrefEnabledPlatform = platform => marketingPrefEnabledPlatforms.includes(platform?.toLowerCase());

const shouldStoreMarketingRecord = (platform, marketingEmailAccepted, confirmedUnder16) =>
  typeof marketingEmailAccepted === 'boolean' &&
  typeof confirmedUnder16 === 'boolean' &&
  isMarketingPrefEnabledPlatform(platform?.toLowerCase());

module.exports = {
  isMarketingPrefEnabledPlatform,
  shouldStoreMarketingRecord
};
